import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';
import { Solicitacao } from '@/types/solicitacao';

export const useMyGroupTickets = (enabled: boolean = false) => {
  const { user } = useAuth();
  
  return useQuery({
    queryKey: ['my-group-tickets', user?.id],
    queryFn: async () => {
      if (!user?.id) {
        return [];
      }

      // Primeiro, buscar os grupos do usuário logado
      const { data: userGroups, error: groupError } = await supabase
        .from('user_groups')
        .select('group_id')
        .eq('user_id', user.id);

      if (groupError) {
        console.error('Erro ao buscar grupos do usuário:', groupError);
        throw groupError;
      }

      const groupIds = userGroups?.map(ug => ug.group_id) || [];
      
      if (groupIds.length === 0) {
        return [];
      }

      // Buscar tickets onde o grupo responsável é um dos grupos do usuário
      // Independente do cliente (não aplicar filtro de cliente)
      const { data, error } = await supabase
        .from('solicitacoes')
        .select(`
          *,
          categoria:categorias_servico(nome),
          solicitante:users!solicitacoes_solicitante_id_fkey(name),
          cliente:clients(name),
          grupo_responsavel:groups(name),
          atendente:users!solicitacoes_atendente_id_fkey(name)
        `)
        .in('grupo_responsavel_id', groupIds)
        .not('status', 'in', '("resolvida","fechada")')
        .order('criado_em', { ascending: false });

      if (error) {
        console.error('Erro ao buscar tickets do meu grupo:', error);
        throw error;
      }

      return (data || []) as Solicitacao[];
    },
    enabled: enabled && !!user?.id,
  });
};